import { RefinementCtx, z } from 'zod';

import { makeUnknownValuePlaceholderSchema } from './unknownValuePlaceholder';

export function makeProtobufEnumSchema<K extends string, V extends number, TFallback = V>(
  protobufEnum: {
    [k in K]: V;
  },
  fallbackValue: TFallback,
) {
  // Generated protobuf enums are numeric TypeScript enums, whose reverse-mapped member names are
  // not valid values. We use only the numbers.
  const values = Object.values(protobufEnum).filter((value) => typeof value === 'number') as V[];
  return makeUnknownValuePlaceholderSchema(z.literal(values), fallbackValue);
}

export function makeTypescriptEnumSchema<
  K extends string,
  V extends number | string,
  TFallback = V,
>(typescriptEnum: { [k in K]: V }, fallbackValue: TFallback) {
  // Includes the reverse-mapped member names of numeric values
  const values: V[] = Object.values(typescriptEnum);
  return makeUnknownValuePlaceholderSchema(z.literal(values), fallbackValue);
}

export function makeExcludeValuesTransform<V, E extends number>(...excludeValues: E[]) {
  return (v: V, ctx: RefinementCtx) => {
    if (excludeValues.includes(v as any)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Unexpected value ${v}`,
      });
      return z.NEVER;
    }
    return v as Exclude<V, E>;
  };
}
